import firebase from '@/firebase'
const db = firebase.db

const state = {
  countries: []
}

const getters = {
  countries: state => {
    return state.countries
  }
}

const actions = {
  loadCountries (context, payload) {
    return new Promise((resolve, reject) => {
      db.collection('settings').doc('countries').get().then(function (snapshot) {
        let countries = []
        if (typeof snapshot.data === 'function' && snapshot.data() && snapshot.data().countries) {
          // Sort countries alphabetically by name
          countries = Object.entries(snapshot.data().countries).sort((a, b) => a[1].name.localeCompare(b[1].name)).map(item => item[1])
        }
        context.commit('setCountries', {
          countries: countries
        })
        resolve()
      }).catch(error => {
        console.log(error)
        reject(error)
      })
    })
  },
  saveCountries (context, payload) {
    db.collection('settings').doc('countries').set({
      countries: JSON.parse(payload.countries)
    }).then(function (docRef) {
      console.log('Settings-Countries updated')
      context.dispatch('loadCountries')
    }).catch(function (error) {
      console.error('Error updating Settings-Countries', error)
    })
  }
}

const mutations = {
  setCountries (state, payload) {
    state.countries = payload.countries
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
